const HOJA_QUIRURGICA_STORAGE_KEY = 'hojas_quirurgicas';
//Temporal
export const saveHojaQuirurgica = (numeroIngreso, hojaData) => {
  try {
    const existingHojas = getHojasQuirurgicas();
    const updatedHojas = {
      ...existingHojas,
      [numeroIngreso]: {
        ...hojaData,
        fechaCreacion: new Date().toISOString(),
        fechaModificacion: new Date().toISOString()
      }
    };
    
    localStorage.setItem(HOJA_QUIRURGICA_STORAGE_KEY, JSON.stringify(updatedHojas));
    return true;
  } catch (error) {
    console.error('Error saving hoja quirurgica:', error);
    return false;
  }
};

export const getHojaQuirurgica = (numeroIngreso) => {
  try {
    const hojas = getHojasQuirurgicas();
    return hojas[numeroIngreso] || null;
  } catch (error) {
    console.error('Error getting hoja quirurgica:', error);
    return null;
  }
};

export const getHojasQuirurgicas = () => {
  try {
    const stored = localStorage.getItem(HOJA_QUIRURGICA_STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.error('Error getting hojas quirurgicas:', error);
    return {};
  }
};

export const hasHojaQuirurgica = (numeroIngreso) => {
  const hoja = getHojaQuirurgica(numeroIngreso);
  return hoja !== null;
};

export const deleteHojaQuirurgica = (numeroIngreso) => {
  try {
    const existingHojas = getHojasQuirurgicas();
    delete existingHojas[numeroIngreso];
    localStorage.setItem(HOJA_QUIRURGICA_STORAGE_KEY, JSON.stringify(existingHojas));
    return true;
  } catch (error) {
    console.error('Error deleting hoja quirurgica:', error);
    return false;
  }
};

export const updateHojaQuirurgica = (numeroIngreso, hojaData) => {
  try {
    const existingHojas = getHojasQuirurgicas();
    const updatedHojas = {
      ...existingHojas,
      [numeroIngreso]: {
        ...existingHojas[numeroIngreso],
        ...hojaData,
        fechaModificacion: new Date().toISOString()
      }
    };
    
    localStorage.setItem(HOJA_QUIRURGICA_STORAGE_KEY, JSON.stringify(updatedHojas));
    return true;
  } catch (error) {
    console.error('Error updating hoja quirurgica:', error);
    return false;
  }
};
